module.exports = __webpack_public_path__ + "static/media/about.b8012124.png";